import strings from 'owa-strings/owa-mini-common-strings';
import { calculateAccessibleText } from './colorSchemeUtils';
import { ColorScheme } from '../schema/ColorScheme';
import { DEFAULT_OUTLOOK_DARK_THEME_COLOR, DEFAULT_OUTLOOK_THEME_COLOR } from 'mini-theme';

const defaultOutlookLightColorScheme: ColorScheme = {
    text: '',
    textAlt: '',
    accessibleText: {
        schemePrimaryBackground: '',
        schemeLighterBackground: '',
        msColorWhiteBackground: '',
        msColorNeutralLighterBackground: '',
    },
    schemeDarker: '#004578',
    schemeDark: '#0d62aa',
    schemeDarkAlt: '#005a9e',
    schemePrimary: DEFAULT_OUTLOOK_THEME_COLOR,
    schemeSecondary: '#2b88d8',
    schemeTertiary: '#71afe5',
    schemeLight: '#c7e0f4',
    schemeLighter: '#deecf9',
    schemeLighterAlt: '#eff6fc',
    colorName: () => strings.blueCalendarColorText,
};

const defaultOutlookDarkColorScheme: ColorScheme = {
    text: '',
    textAlt: '',
    accessibleText: {
        schemePrimaryBackground: '',
        schemeLighterBackground: '',
        msColorWhiteBackground: '',
        msColorNeutralLighterBackground: '',
    },
    schemeDarker: '#6CB8F6',
    schemeDark: '#3AA0F3',
    schemeDarkAlt: '#1890F1',
    schemePrimary: DEFAULT_OUTLOOK_DARK_THEME_COLOR,
    schemeSecondary: '#2488d8',
    schemeTertiary: '#0078D4',
    schemeLight: '#004C87',
    schemeLighter: '#043862',
    schemeLighterAlt: '#092C47',
    colorName: () => strings.blueCalendarColorText,
};

export const getDefaultOutlookColorScheme = (isDarkTheme?: boolean): ColorScheme => {
    const colorScheme = isDarkTheme
        ? defaultOutlookDarkColorScheme
        : defaultOutlookLightColorScheme;
    colorScheme.accessibleText = calculateAccessibleText(colorScheme);
    colorScheme.text = colorScheme.accessibleText.schemePrimaryBackground;
    colorScheme.textAlt = colorScheme.accessibleText.schemeLighterBackground;
    return colorScheme;
};

export const isDefaultOutlookColor = (color: string): boolean =>
    color === DEFAULT_OUTLOOK_THEME_COLOR;
